export default "__VITE_ASSET__048ab1cb__"